export const REDDIT = 'https://www.reddit.com/r/CoinFalcon/';
export const TELEGRAM = 'https://t.me/coinfalcon';
export const TWITTER = 'https://twitter.com/coinfalcon';
export const FACEBOOK = 'https://www.facebook.com/CoinFalcon/';
export const BLOG = 'https://blog.coinfalcon.com';
